// Importing a bundle, from a PAGE's own screen — which, here, means UPDATE.
//
// WHERE IMPORT IS INVOKED DECIDES WHAT IT DOES. This screen expects the file
// to be THIS page's data — the group it was exported from — and puts the edit
// back into those rows: increment one's behaviour, plus the scope. A file for
// some other page is refused (`page.import.page.mismatch`) rather than
// written to whatever it happens to name, which is the difference between
// "import here" and "import somewhere". The other verb — the file becoming an
// independent new page — is Import on the pages listing.
//
// Everything on screen is `BundleImport` from that listing screen: one flow,
// one plan table, one set of refusal sentences, because the server's rules are
// one implementation too (model/page/bundle's `assertEnvelope`). What differs
// is the mutation — the entity's, so the server knows which page the person
// was looking at — and where a finished apply lands: back on the page.
import React from "react";
import { BreadcrumbItem } from "reactstrap";
import * as PageQL from "queries/page";

import { BundleImport } from "../../import";

export const Sidebar = () => null;

export const Indice = () => <BreadcrumbItem>Import</BreadcrumbItem>;

export const Content = ({
  history,
  match: {
    params,
    params: { siteId, pageId },
  },
}) => (
  <BundleImport
    intro={
      <p>
        A bundle is a page and every other language of it, exported from this
        screen. Importing it here <strong>updates this page</strong> and its
        languages with what the file says: it adds no page, removes none, and a
        file exported from a different page is refused. To bring a file in as a
        new, independent page instead, use Import on the pages listing.
      </p>
    }
    mutation={PageQL.importPage}
    variablesOf={(input) => ({ siteId, pageId, input })}
    resultOf={(data) => data.viewer.account.sites.get.pages.get.import}
    evict={PageQL.update(params)}
    onApplied={() => history.replace(`/site/${siteId}/page/${pageId}/`)}
  />
);
